import { render, staticRenderFns } from "./evolucao-patrimonial.vue?vue&type=template&id=2af3e615&"
import script from "./evolucao-patrimonial.vue?vue&type=script&lang=js&"
export * from "./evolucao-patrimonial.vue?vue&type=script&lang=js&"
import style0 from "./evolucao-patrimonial.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af3e615')) {
      api.createRecord('2af3e615', component.options)
    } else {
      api.reload('2af3e615', component.options)
    }
    module.hot.accept("./evolucao-patrimonial.vue?vue&type=template&id=2af3e615&", function () {
      api.rerender('2af3e615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/evolucao-patrimonial/evolucao-patrimonial.vue"
export default component.exports